import { combineReducers } from 'redux'
import { reducer as login } from './login'
import { reducer as register } from './register'
import { reducer as resetPassword } from './reset-password'
import { reducer as user } from './user'
import { reducer as registerColleague } from './register-colleague'
import { reducer as profile } from './profile'
import { reducer as decryptEmail } from './decrypt-email'

const rootReducer = combineReducers({
  login,
  register,
  resetPassword,
  user,
  registerColleague,
  profile,
  decryptEmail,
})

export default rootReducer
